/**
 * @generated SignedSource<<69c0e9f8a433ca5e0fa7ef04b8dcb0fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductAdminDashboardActionDeleteMutation$variables = {
  id: string;
};
export type ProductAdminDashboardActionDeleteMutation$data = {
  readonly response: {
    readonly node: {
      readonly viewerHasDismissed: boolean;
    } | null;
  };
};
export type ProductAdminDashboardActionDeleteMutation = {
  response: ProductAdminDashboardActionDeleteMutation$data;
  variables: ProductAdminDashboardActionDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasDismissed",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductAdminDashboardActionDeleteMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "DeleteAdminActionDismissalResponse",
        "kind": "LinkedField",
        "name": "deleteAdminActionDismissal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductAdminAction",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductAdminDashboardActionDeleteMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "DeleteAdminActionDismissalResponse",
        "kind": "LinkedField",
        "name": "deleteAdminActionDismissal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductAdminAction",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c9da01903e1cdfdec8606d7e515a636",
    "id": null,
    "metadata": {},
    "name": "ProductAdminDashboardActionDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ProductAdminDashboardActionDeleteMutation(\n  $id: ID!\n) {\n  response: deleteAdminActionDismissal(id: $id) {\n    node {\n      viewerHasDismissed\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "321a35dc46807e33654532697ca777fc";

export default node;
